import { __decorate, __metadata } from "tslib";
import { lazyConsumer, lazyProvider } from '@1inch-community/core/lazy';
import { appendStyle, observeMutations, resizeObserver, subscribe, } from '@1inch-community/core/lit-utils';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BehaviorSubject, merge, Subject, tap } from 'rxjs';
import { scrollContext } from './scroll-context';
let ScrollViewProviderElement = class ScrollViewProviderElement extends LitElement {
    constructor() {
        super(...arguments);
        this.scrollTopFromConsumer$ = new BehaviorSubject(0);
        this.showStubView$ = new BehaviorSubject(false);
        this.lockedConsumer$ = new BehaviorSubject(false);
        this.update$ = new Subject();
        this.context = lazyProvider(this, { context: scrollContext });
        this.contextParent = lazyConsumer(this, { context: scrollContext });
    }
    static { this.tagName = 'inch-scroll-view-provider'; }
    static { this.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      position: relative;
    }
  `; }
    get scrollTopFromConsumer() {
        return this.scrollTopFromConsumer$.value ?? 0;
    }
    setScrollTopFromConsumer(state) {
        this.scrollTopFromConsumer$.next(state);
    }
    onChangeStubView(state) {
        this.showStubView$.next(state);
    }
    takeUpdate() {
        this.update$.next();
    }
    onLockedConsumer(state) {
        this.lockedConsumer$.next(state);
    }
    firstUpdated() {
        if (this.contextParent.isInit) {
            this.context.set(this.contextParent.value);
            return;
        }
        this.context.set(this);
        subscribe(this, [
            merge(resizeObserver(this), observeMutations(this, { attributes: true, attributeFilter: ['style', 'class'] })).pipe(tap(() => {
                this.takeUpdate();
            })),
        ], { requestUpdate: false });
    }
    updated() {
        if (this.contextParent.isInit)
            return;
        appendStyle(this, {
            maxHeight: this.maxHeight ? `${this.maxHeight}px` : '',
            height: this.setMaxHeight ? `${this.maxHeight}px` : '',
        });
    }
    render() {
        return html `<slot></slot>`;
    }
};
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Number)
], ScrollViewProviderElement.prototype, "maxHeight", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Boolean)
], ScrollViewProviderElement.prototype, "setMaxHeight", void 0);
ScrollViewProviderElement = __decorate([
    customElement(ScrollViewProviderElement.tagName)
], ScrollViewProviderElement);
export { ScrollViewProviderElement };
//# sourceMappingURL=scroll-view-provider.element.js.map